import { get } from "../../utils/request";

export const checkExistEmail = async (email) => {
  const res = await get(`users?email=${email}`);
  return res;
};

export const loginUser = async (email, password) => {
  const res = await get(`users?email=${email}&password=${password}`);
  return res;
};

export const getInfoUser = async (email, token) => {
  const res = await get(`users?email=${email}&token=${token}`);
  return res;
};
